import axios from 'axios';

/**
 * Get VONQ getProductsSupportingContracts
 * @returns 
 */
export async function getContracts({userId}) {
    const { data } = await axios.get(`/vonq/${userId}/getContracts`);
    return data;
}

/**
 * Get VONQ getContractsByIds
 * @param userId
 * @param contractIds
 * @returns
 */
export async function getContractsByIds({userId, contractIds}) {
    const { data } = await axios.get(`/vonq/${userId}/getContractsByIds`, {
        params: {
            contractIds
        }
    });
    return data;
}


/**
 * Get VONQ getProductsSupportingContracts
 * @returns 
 */
export async function createContract({userId, body}) {
    const { data } = await axios.post(`/vonq/${userId}/createContract`, body);
    return data;
}


export async function deleteContract({userId, contractId}) {
    const { data } = await axios.delete(`/vonq/${userId}/deleteContract/${contractId}`);
    return data;
}

export async function contractAutocompleteValues({userId, contractId, params}) {
    const { data } = await axios.post(`/vonq/${userId}/contractAutocompleteValues/${contractId}`, {
        params: {...params}
    });
    return data;
}